// manageAuth.ts
import { User } from "../types/authTypes";
import { getLocalStorage, setLocalStorage, removeLocalStorage } from "./manageStorage";

const AUTH_USER_KEY = "authUser";

export const getAuthUser = (): User | null => getLocalStorage(AUTH_USER_KEY);

export const setAuthUser = (user: User) => setLocalStorage(AUTH_USER_KEY, user);

export const removeAuthUser = () => removeLocalStorage(AUTH_USER_KEY);

export const getAccessToken = (): string | null => getAuthUser()?.accessToken || null;

/**
 * The account whose data the signed-in user works on: the company owner's id for team members
 * (admins and agents), otherwise the user's own id. Use it for customers, chats, templates, wallet...
 * but not for the user's own profile.
 */
export const getDataUserId = (): string | undefined => {
  const u = getAuthUser();
  return u?.clientUserId || u?.userId;
};

/** OWNER, ADMIN or AGENT (accounts from before teams count as OWNER). */
export const getTeamRole = (): "OWNER" | "ADMIN" | "AGENT" =>
  (getAuthUser()?.teamRole as "OWNER" | "ADMIN" | "AGENT") || "OWNER";

/** Owners and admins manage billing, the team, API keys and the WhatsApp number; agents don't. */
export const isTeamAdmin = (): boolean => getTeamRole() !== "AGENT";
